<template></template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
    mounted() {
        setInterval(() => {
            this.postUpdate();
        }, 15 * 1000);
    },

    computed: mapState(['contact']),

    methods: {
        async postUpdate() {
            await axios.post('/api/email-delays/update', {
                contact_id: this.contact.ips_id,
            });
        },
    },
};
</script>
